<template>
	<div class="full-parent ">
		<div class="header full-parent" style="position: relative;">
			<div class="jidian-container">
				<div class="jidian-container">
					<div class="jibai" :class="{'fade':isJiBai1}" v-show="isJiBai">
						<div :style="{marginLeft: jibaiPosition}">
							<img src="/static/img/jibai.png" style="height: 460px;" alt="">
						</div>
					</div>
					<div class="xianhua" v-show="isXianHua">
						<div style="display: flex;justify-content: space-between;">
							<div>
								<img class="xianhua-img" :src="huaImg" alt="">
								<img class="hualan-img" :src="basketImg" alt="">
							</div>

							<div>
								<img class="xianhua-img" :src="huaImg" alt="">
								<img class="hualan-img" :src="basketImg" alt="">
							</div>

						</div>
					</div>
					<div class="dianla" v-show="isDianLa">
						<div style="display: flex;justify-content: space-between;">
							<img class="dianla-img" :src="laImg" alt="">
							<img class="dianla-img" :src="laImg" alt="">
						</div>
					</div>
					<div class="shangxiang flex" v-show="isXiang">
						<img :src="xinagImg" alt="" style="width:56px;height: 90px;">
						<img :src="guopanImg" alt="" style="width:71px; height: 59px;margin-left: -30px;margin-top: 80px;">
					</div>
				</div>
			</div>
			<div class="jidian-num">累计 <span class="number">{{num}}</span> 人祭奠</div>
			<div class="jidian-list">
				<template v-for="(item,index) in jiList">
					<div class="jidian-list-hua-box" @click="ji(index)">
						<div><img class="jidian-list-hua" :src="item.img" alt=""></div>
						<div style="color: #38932E;font-size: 16px;">{{item.txt}}</div>
					</div>
				</template>
			</div>
			<div class="jidian-hua-list" v-show="visibleSelHua">
				<template v-for="(item,index) in huaList">
					<div class="jidian-hua-list-box" @click="selHua(index)">
						<img class="jidian-hua-list-img" :src="item" alt="">
					</div>
				</template>
			</div>
		</div>
		<div class="leavingmsg-container">
			<div style="width: 1320px;display: flex;justify-content: space-between;margin: 0 auto;">
				<div class="leavingmsg-box">
					<span style="margin-left: 20px;">祭奠者：</span>
					<input type="text" class="leavingmsg-input" v-model="form.name">
				</div>
				<div class="leavingmsg-box">
					<span style="margin-left: 20px;">留言：</span>
					<input type="text" placeholder="缅怀先烈，致敬英雄" v-model="form.content" class="leavingmsg-input">
				</div>
				<div class="leavingmsg-btn" @click="submitComment()">发布</div>
			</div>
			<div class="leavingmsg-show">留言展示</div>
			<div class="leavingmsg-list">
				<template v-for="item in comments.content">
					<div class="leavingmsg-list-item">
						<div class="leavingmsg-info">
							<span class="leavingmsg-name">{{item.name}}</span>
							<span class="leavingmsg-date">{{deteFormat(new Date(item.publishTime), "yyyy.MM.dd hh:mm:ss")}}</span>
						</div>
						<div class="leavingmsg-content">{{item.content}}</div>
						<div class="border-dashed"></div>
					</div>
				</template>
				<div class="pn" style="margin-top: 50px;">
					<el-pagination background layout="prev, pager, next" :total="comments.totalElements" @current-change="changePage">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import api from '../../http/commemorate'
	import {
		formatTimeToStr
	} from '../../utils/date.js'
	export default {
		data() {
			return {
				visibleSelHua: false,
				huaImg: '/static/img/f1.png',
				laImg: '/static/img/zhutai.png',
				xinagImg: '/static/img/xiang.png',
				guopanImg: '/static/img/shuiguo.png',
				basketImg: '/static/img/basket.png',
				jibaiTimer: null,
				isJiBai: false,
				isJiBai1: false,
				isXianHua: false,
				isDianLa: false,
				isXiang: false,
				jibaiPosition: '0px',
				jiList: [{
						txt: '祭拜',
						img: '/static/img/ren.png'
					},
					{
						txt: '献花',
						img: '/static/img/f1.png'
					},
					{
						txt: '点蜡',
						img: '/static/img/zhutai.png'
					},
					{
						txt: '上香',
						img: '/static/img/xiang.png'
					},
				],
				huaList: ['/static/img/f1.png', '/static/img/f2.png', '/static/img/f3.png', '/static/img/f4.png'],
				num: null,
				form: {
					name: null,
					content: null,
					heroId: null
				},
				page: {
					page: 0,
					size: 10,
					sort: "id,desc"
				},
				comments: []

			}
		},
		mounted() {},
		methods: {
			selHua(index) {
				this.huaImg = this.huaList[index]
				this.isXianHua = true
				this.visibleSelHua = false
			},
			ji(index) {
				if (index == 0) {
					if (!this.isJiBai) {
						this.isJiBai = true
						this.isJiBai1 = false
						this.jibaiPosition = '0px'
						this.jibai()
						this.addNum()
					}
				} else if (index == 1) {
					this.visibleSelHua = true
				} else if (index == 2) {
					this.isDianLa = true
				} else if (index == 3) {
					this.isXiang = true
				}
			},
			jibai() {
				let t = 0
				let num = 0
				let jibaiStep = 226
				let jibaiNum = 0
				this.jibaiTimer = setInterval(() => {
					this.jibaiPosition = '-' + (jibaiNum * jibaiStep) + 'px'
					if (t == 0) {
						jibaiNum++
					} else {
						jibaiNum--
					}
					if (jibaiNum == 10) {
						t = 1
					} else if (jibaiNum == 0) {
						t = 0
						num++
					}
					if (num == 3) {
						clearInterval(this.jibaiTimer)
						setTimeout(() => {
							this.isJiBai1 = true
						}, 2000)

						setTimeout(() => {
							this.isJiBai = false
						}, 3000)
					}
				}, 150)
			},
			getCommemorateNum() {
				const _this = this;
				api.getCommemorateNum().then(res => {
					_this.num = res;
				})
			},
			addNum() {
				const _this = this;
				api.commemorate().then(res => {
					_this.num = res;
				})
			},
			getComments() {
				const _this = this;
				api.getPublicComments(this.page).then(res => {
					_this.comments = res;
				})
			},
			submitComment() {
				api.publicComment(this.form).then(res => {
					this.form = {
						name: null,
						content: null
					}
					this.getComments();
					this.$alert("留言成功", '提示', {
						confirmButtonText: '确定',
						type: "success"
					});
				}).catch(err => {
					this.$alert(err.message, '留言失败', {
						confirmButtonText: '确定',
						type: "error"
					});
				})
			},
			changePage(current) {
				this.page.page = current - 1;
				this.getComments();
			},
			deteFormat(date, formatter) {
				return formatTimeToStr(date, formatter);
			},
		},
		created() {
			this.getCommemorateNum();
			this.getComments();
		}
	}
</script>

<style scoped="scoped">
	.header {
		display: flex;
		/* align-items: center; */
		background-image: url("/static/img/jinianbei.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.jidian-num {
		position: absolute;
		bottom: 24px;
		left: 117px;
		font-size: 28px;
		color: #fff;
	}

	.number {
		font-size: 40px;
		color: #29514B;
	}

	.jidian-container {
		width: 450px;
		height: 500px;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
	}

	.xianhua {
		position: absolute;
		top: 290px;
		width: 430px;
		z-index: 1;
		left: 0;
		right: 0;
		margin: auto;
	}

	.xianhua-img {
		height: 74px;
		display: block;
		margin: 0 auto;
	}

	.dianla {
		position: absolute;
		top: 280px;
		width: 206px;
		z-index: 3;
		left: 0;
		right: 0;
		margin: auto;
	}

	.dianla-img {
		width: 48px;
		height: 94px;
	}

	.shangxiang {
		position: absolute;
		top: 266px;
		width: 56px;
		z-index: 3;
		left: 0;
		right: 0;
		margin: auto;
	}

	@-webkit-keyframes fadeIn {
		0% {
			opacity: 1;
			/*初始状态 透明度为0*/
		}

		50% {
			opacity: 0;
			/*中间状态 透明度为1*/
		}
	}

	.fade {
		-webkit-animation: fadeIn 2s infinite linear;
	}

	.jibai {
		width: 220px;
		position: absolute;
		bottom: 0px;
		left: 0;
		right: 0;
		margin: auto;
		overflow: hidden;
		z-index: 4;
	}

	.jidian-list {
		position: absolute;
		width: 80px;
		bottom: 50px;
		right: 68px;
	}

	.jidian-list-hua-box {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		background-color: #fff;
		margin-bottom: 16px;
		cursor: pointer;
	}

	.jidian-list-hua {
		margin-top: 6px;
		width: 30px;
		height: 46px;
	}

	.jidian-hua-list {
		position: absolute;
		width: 120px;
		bottom: 0;
		right: 196px;
		background-color: rgba(0, 0, 0, 0.3);
		padding: 20px 0;
	}

	.jidian-hua-list-box {
		cursor: pointer;
		margin: 10px 0;
	}

	.jidian-hua-list-img {
		height: 86px;
	}

	.leavingmsg-container {
		background-color: #283447;
		padding-top: 90px;
	}

	.leavingmsg-box {
		width: 475px;
		height: 74px;
		border: 1px solid #fff;
		border-radius: 37px;
		background-color: #4B5E7B;
		display: flex;
		align-items: center;
		font-size: 20px;
		color: #fff;
		font-family: Microsoft YaHei;
	}

	.leavingmsg-input {
		background-color: #3A4960;
		border: 0;
		line-height: 50px;
		font-size: 20px;
		padding: 0 18px;
		width: 320px;
		color: #fff;
	}

	.leavingmsg-btn {
		background-color: #4B5E7B;
		width: 148px;
		line-height: 74px;
		border: 1px solid #fff;
		border-radius: 37px;
		text-align: center;
		color: #fff;
		font-size: 20px;
	}

	.leavingmsg-show {
		width: 249px;
		line-height: 71px;
		background-image: url("/static/img/liuyan-bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		margin: 103px auto 0;
		font-size: 24px;
		color: #fff;
		text-align: center;
	}

	.leavingmsg-list {
		width: 1320px;
		margin: 0 auto;
		color: #fff;
		padding: 50px 0;
	}

	.leavingmsg-info {
		text-align: left;
		margin-top: 30px;
		padding-left: 10px;
	}

	.leavingmsg-name {
		font-weight: bold;
		font-size: 20px;
	}

	.leavingmsg-date {
		font-size: 16px;
		margin-left: 20px;
	}

	.leavingmsg-content {
		text-align: left;
		font-size: 18px;
		margin-top: 30px;
		padding-left: 10px;
	}

	.border-dashed {
		background-image: url(/static/img/border-dashed.png);
		height: 1px;
		margin-top: 30px;
	}

	input::-webkit-input-placeholder {
		color: #fff;
	}

	input::-moz-input-placeholder {
		color: #fff;
	}

	input::-ms-input-placeholder {
		color: #fff;
	}

	.hualan-img {
		width: 120px;
		position: relative;
		top: -70px;
		z-index: 100;
	}
</style>



// WEBPACK FOOTER //
// src/views/commemorate/monument.vue